enum PrintableContentEnum {
	productListTab = 'productListTab',
	imagesTab = 'imagesTab',
	securityTab = 'securityTab',
	customPrintContent = 'customPrintContent'
}

export default PrintableContentEnum;
